import {ManageEmployeeStateActions as actions} from '../../const/actionType';

export const setDepartments = (departments) => ({
  type: actions.SET_DEPARTMENTS,
  departments,
});

export const setPractice = (practices) => ({
  type: actions.SET_PRACTICES,
  practices,
});

export const setAuthRoles = (authRoles) => ({
  type: actions.SET_AUTH_ROLES,
  authRoles,
});

export const setRoleLevels = (roleLevels) => ({
  type: actions.SET_ROLE_LEVELS,
  roleLevels,
});

export const setCompanies = (companies) => ({
  type: actions.SET_COMPANIES,
  companies,
});

export const setNewEmployee = (newEmployee) => ({
  type: actions.SET_NEW_EMPLOYEE,
  newEmployee,
});

export const showModal = () => ({
  type: actions.SHOW_MODAL,
});

export const hideModal = () => ({
  type: actions.HIDE_MODAL,
});

export const setModalType = (modalType) => ({
  type: actions.SET_MODAL_TYPE,
  modalType,
});

export const setNewEmployeeByKey = (key, value) => ({
  type: actions.SET_NEW_EMPLOYEE_BY_KEY,
  key,
  value,
});

export const setSortValue = (sortValue) => ({
  type: actions.SET_SORT_VALUE,
  sortValue,
});

export const setFilterMap = (filterMap) => ({
  type: actions.SET_FILTER_MAP,
  filterMap,
})

export const setPageSize = (pageSize) => ({
  type: actions.SET_PAGE_SIZE,
  pageSize
});

export const setPageNo = (pageNo) => ({
  type: actions.SET_PAGE_NO,
  pageNo
});

export const setPageIndex = (pageIndex) => ({
  type: actions.SET_PAGE_INDEX,
  pageIndex
});

export const setTotalItem = (totalItem) => ({
  type: actions.SET_TOTAL_ITEM,
  totalItem,
});

export const setResponseStatus = (responseStatus) => ({
  type: actions.SET_RESPONSE_STATUS,
  responseStatus
});

export const setEmployees = (employees) => ({
  type: actions.SET_EMPLOYEES,
  employees
});

export const resetNewEmployee = () => ({
  type: actions.RESET_NEW_EMPLOYEE
});

export const setSelectedTab = (selectedTab) => ({
  type: actions.SET_SELECTED_TAB,
  selectedTab
});

export const resetState = () => ({
  type: actions.RESET_STATE
});

export const setInitialState = () => ({
  type: actions.SET_INITIAL_STATE
});

export default actions;